const MATCH_MOBILE = /^Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/i;

export const getDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobile = Boolean(userAgent.match(MATCH_MOBILE));
  return mobile ? 'mobile' : 'desktop';
};
